import { useTranslation } from "react-i18next";
import PageHeader from "../../../components/Common/PageHeader";
import TableFilterDynamique from "components/Common/TableFilter/TableFilterDynamique";
import { FilterField } from "../../../components/Common/TableFilter/TableFilter";
import AddEditUserManagement from "../modals/AddEditUserManagement";
import UserManagementTable from "../tables/userManagementTable";
import useUserManagement from "../hooks/useUserManagement";
import { useEffect, useState } from "react";
import CustomButton from "components/Common/ui/CustomButton";
import { useAbility } from "config/abilityContext";
import { all_routes } from "router/all_routes";

const UserManagement = () => {
  const { t } = useTranslation();
  const {
    users,
    loading,
    selectedUser,
    setSelectedUser,
    isModalOpen,
    setIsModalOpen,
    fetchUsers,
    handleCreate,
    handleUpdate,
    handleDelete
  } = useUserManagement();

  const breadcrumbItems = [
    { label: "dashboard", path: "/dashboard" },
    { label: "user_management", active: true },
  ];

  const ability = useAbility();

  const [filters, setFilters] = useState<{
    [key: string]: string | number | null;
  }>({});
  const filterFields: FilterField[] = [
    { key: "search", label: t("search"), type: "text" },
    {
      key: "role",
      label: t("role"),
      type: "select",
      options: [
        { value: "pedagogy-director", label: t("pedagogy-director") },
        { value: "director", label: t("director") },
      ]
    }
  ];
  useEffect(() => {
    fetchUsers();
  }, []);

  const handleFilter = (newFilters: {
    [key: string]: string | number | null;
  }) => {
    console.log(newFilters, "newFilters");
    setFilters(newFilters);
    fetchUsers(newFilters);
  };

  const handleSaveUser = async (userData: any) => {
    try {
      if (selectedUser) {
        await handleUpdate(selectedUser.id, userData);
      } else {
        await handleCreate(userData);
      }
      //   setIsModalOpen(false);
    } catch (error) {
      console.error(error);
    }
  };

  const handleEdit = (record: any) => {
    setSelectedUser(record);
    setIsModalOpen(true);
  };

  return (
    <div className="page-wrapper">
      <div className="content container-fluid">
        <PageHeader
          title={t("user_management")}
          breadcrumbItems={breadcrumbItems}
        />

        <div className="d-flex mb-3 justify-content-end gap-2">
          {ability.can("create", "UserManagement") && (
            <CustomButton
              asLink
              to={all_routes.UserManagementCreate}
            >
              <i className="ti ti-plus me-2" />
              {t("add_user_management")}
            </CustomButton>
          )}
          <TableFilterDynamique
            fields={filterFields}
            filters={filters}
            onApply={handleFilter}
            onReset={() => {
              setFilters({});
              fetchUsers({});
            }}
          />
        </div>

        <UserManagementTable
          dataSource={users}
          onEdit={handleEdit}
          onDelete={handleDelete}
          loading={loading}
        />

        <AddEditUserManagement
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          userData={selectedUser}
          onSave={handleSaveUser}
        />
      </div>
    </div>
  );
};

export default UserManagement;